export class Jobseekerdata {
    profileData: {
      jsId: number;
      firstName: string;
      middleName: string;
      lastName: string;
      emailId: string;
      countryCode: string;
      primaryContact: string;
      ssnNo: string;
      dob: string;
      streetName: string;
      countryId: string;
      stateId: string;
      zipCode: string;
      city: string;
      secondaryCountryCode: string;
      secondaryContact: string;
      citizenship: string;
      isVisa: string;
      validTill: string;
      visaType: string;
      jobType: string;
      securityClearance: string;
      availabilityJoin: string;
      availabilityTime: string;
      createdDate: string;
      createdBy: string;
      profileImageName: string;
      resumeName: string;
      epId: number;
      supplierId: number;
      fullName:string,
      resumeNamePath:string,
      profileImageNamePath:string,
      contact:string
    }={
        jsId: 0,
        firstName: "",
        middleName: "",
        lastName: "",
        emailId: "",
        countryCode: "",
        primaryContact: "",
        ssnNo: "",
        dob: "",
        streetName: "",
        countryId: "",
        stateId: "",
        zipCode: "",
        city: "",
        secondaryCountryCode: "",
        secondaryContact: "",
        citizenship: "",
        isVisa: "",
        validTill: "",
        visaType: "",
        jobType: "",
        securityClearance: "",
        availabilityJoin: "",
        availabilityTime: "",
        createdDate: "",
        createdBy: "",
        profileImageName: "",
        resumeName: "",
        epId: 0,
        supplierId: 0,
        fullName:"",
        resumeNamePath:"",
        profileImageNamePath:"",
        contact:""
    };
    professionalData: {
      jsId: number;
      highestDegree: string;
      universityName: string;
      dateOfQualification: string;
      countryId: string;
      stateId: string;
      city: string;
      isUsDegree: string;
      payRate: number | null;
      totalExperience: string;
      reLocation: string;
      recentEmployer: string;
      currentJobTitle: string;
      currency: string;
      frequency: string;
      createdDate: string;
      createdBy: string;
      jspId: number;
    }= {
        jsId: 0,
        highestDegree: "",
        universityName: "",
        dateOfQualification: "",
        countryId: "",
        stateId: "",
        city: "",
        isUsDegree: "",
        payRate: null,
        totalExperience: "",
        reLocation: "",
        recentEmployer: "",
        currentJobTitle: "",
        currency: "",
        frequency: "",
        createdDate: "",
        createdBy: "",
        jspId: 0
    };
    refData: {
      companyName: string;
      contactPerson: string;
      jobTitle: string;
      contactPhone: string;
      refDate: string;
      contactEmail: string;
      createdDate: string;
      createdBy: string;
      updatedBy: string;
      updatedDate: string;
      expiryDate: string;
      isActive: boolean;
      jsId: number;
      referenceId: number;
    }[] = [];
    skillData: {
      skill: string;
      secondarySkill: string;
      suggestedKeywords: string;
      resumeSummary: string;
      skillsCreatedDate: string;
      skillsCreatedBy: string;
      jsId: number;
      skillsId: number;
    } = {
      skill: '',
      secondarySkill: '',
      suggestedKeywords: '',
      resumeSummary: '',
      skillsCreatedDate: '',
      skillsCreatedBy: '',
      jsId: 0,
      skillsId: 0
    };
    otherData: {
      contactType: string;
      contactValue: string;
      otherCreatedDate: string;
      otherCreatedBy: string;
      otherJsId: number;
      contactsId: number;
    }[] = [];
    docData: {
      docType: string;
      docName: string;
      docFile: string;
      file: string;
      docsCreatedDate: string;
      docsCreatedBy: string;
      docsJsId: number;
      docsId: number;
      isDelete: boolean;
    }[] = [];
  }
  